
export type UnauthorizedErrorResponse = {
  error?: string;
  message?: string;
  timestamp?: string;
};
